import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import styled from "styled-components";
import backgroundImage from "./assets/bg.png";
import Icon from "./icon";
import { DefaultFontStack } from "../typography/typography";

const Root = styled.div(DefaultFontStack, {
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  "@media(min-width: 800px)": {
    backgroundPositionY: -80,
  },
});

const Content = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: 16,
  gap: 16,
  "@media(min-width: 800px)": {
    alignItems: "center",
    flexDirection: "row",
    padding: 32,
    gap: 32,
  },
});

const ContentTextContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  gap: 16,
  color: theme.colors.day,
  "> span:first-of-type": {
    fontSize: 30,
    fontWeight: 700,
    "@media(min-width: 800px)": {
      maxWidth: 450,
    },
  },
  "> span:nth-of-type(2)": {
    fontSize: 20,
    fontWeight: 400,
  },
  "@media(min-width: 800px)": {
    flexBasis: 465,
    flexShrink: 0,
    alignItems: "flex-start",
  },
}));

const StyledLink = styled.a(({ theme }) => ({
  border: "2px solid rgb(212, 215, 221)",
  borderRadius: 40,
  color: "#000000",
  display: "flex",
  gap: 10,
  alignItems: "center",
  padding: "5px 20px",
  backgroundColor: theme.colors.day,
  fontWeight: 400,
  fontSize: 17,
  width: "fit-content",
  lineHeight: "30px",
  "&:hover": {
    backgroundColor: "rgb(82, 114, 182)",
    color: theme.colors.day,
  },
}));

const Footer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: 10,
  alignItems: "center",
  backgroundColor: "#073e6a",
  color: theme.colors.day,
  padding: 16,
  boxSizing: "border-box",
  "> div:first-of-type": {
    "> div": {
      paddingLeft: 30,
      borderLeft: `1px solid ${theme.colors.day}`,
      "&:first-of-type": {
        paddingLeft: 0,
        borderLeft: "none",
      },
      ":nth-of-type(4)": {
        display: "none",
      },
      ":last-of-type": {
        display: "none",
      },
      "@media(min-width: 768px)": {
        ":nth-of-type(4)": {
          display: "flex",
        },
        ":last-of-type": {
          display: "flex",
        },
      },
    },
  },
  "> div:nth-of-type(2)": {
    display: "flex",
    "> div": {
      paddingLeft: 30,
      ":first-of-type": {
        paddingLeft: 0,
      },
      ":last-of-type": {
        borderLeft: `1px solid ${theme.colors.day}`,
      },
    },
    "@media(min-width: 768px)": {
      display: "none",
    },
  },
}));

const Row = styled.div({
  display: "flex",
  gap: 30,
});

const Item = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,

  textAlign: "center",

  "> span:first-of-type": {
    fontSize: 28,
    fontWeight: 500,
  },
}));

function BannerAd() {
  let url;

  if (process.env.GATSBY_SITE === "vorne.com") {
    url = "/";
  } else {
    url = "https://www.vorne.com";
  }

  return (
    <Root data-component-name="banner-ad">
      <Content>
        <ContentTextContainer>
          <span>
            The Manufacturing Productivity Improvement Device That Feels Like{" "}
            <em>Magic</em>
          </span>
          <span>
            In <em>less than 8 hours</em> you can benefit from automated,
            real-time accurate data.
          </span>
          <StyledLink href={url}>
            Learn About Vorne XL
            <Icon />
          </StyledLink>
        </ContentTextContainer>
        <StaticImage alt="XL HD Run Screen" src="assets/screen.png" />
      </Content>
      <Footer>
        <Row>
          <Item>
            <span>42,000+</span>
            <span>Installations</span>
          </Item>
          <Item>
            <span>45+</span>
            <span>Countries</span>
          </Item>
          <Item>
            <span>$3,990</span>
            <span>One-Time Cost</span>
          </Item>
          <Item>
            <span>8</span>
            <span>Hours to Deploy</span>
          </Item>
          <Item>
            <span>50+</span>
            <span>Years in Business</span>
          </Item>
        </Row>
        <Row>
          <Item>
            <span>8</span>
            <span>Hours to Deploy</span>
          </Item>
          <Item>
            <span>50+</span>
            <span>Years in Business</span>
          </Item>
        </Row>
      </Footer>
    </Root>
  );
}

export default BannerAd;
